import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function base({ size = 16, ...rest }: IconProps) {
  return {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "currentColor",
    ...rest,
  };
}

export function MarkerIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12,.042a9.992,9.992,0,0,0-9.981,9.98c0,2.57,1.99,6.592,5.915,11.954a5.034,5.034,0,0,0,8.132,0c3.925-5.362,5.915-9.384,5.915-11.954A9.992,9.992,0,0,0,12,.042ZM12,14a4,4,0,1,1,4-4A4,4,0,0,1,12,14Z" />
    </svg>
  );
}

export function ClockIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="m14.181.207a1 1 0 0 0 -1.181.983v2.879a7.954 7.954 0 0 0 -8.931 8.931h-2.879a1 1 0 0 0 -.983 1.181 12 12 0 1 0 13.974-13.974zm-2.181 13.793a1.994 1.994 0 0 1 -1.723-1h-2.277a1 1 0 0 1 0-2h2.277a2 2 0 0 1 .723-.723v-3.277a1 1 0 0 1 2 0v3.277a1.994 1.994 0 0 1 -1 3.723zm-2.028-13.9a1 1 0 1 1 -1 1 1 1 0 0 1 1-1zm-4.1 1.756a1 1 0 1 1 -1 1 1 1 0 0 1 .997-1.002zm-3.093 2.985a1 1 0 1 1 -1 1 1 1 0 0 1 1-1zm-1.6 4.167a1 1 0 1 1 -1 1 1 1 0 0 1 .998-1z" />
    </svg>
  );
}

export function MusicIcon(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M22.571,15.857c.16-1.417,.29-4.164,.29-6.122,0-4.828-.803-6.537-.964-6.831-.144-.261-.361-.474-.625-.61-.131-.067-3.243-1.653-6.864-1.218-4.447,.533-6.888,3.536-6.989,3.664-.115,.145-.203,.31-.259,.485-.034,.111-.848,2.761-.848,7.583,0,.532,.009,1.069,.027,1.605-.295-.039-.609-.058-.944-.058-2.825,0-4.258,1.455-4.258,4.323,0,2.909,1.393,4.322,4.258,4.322,2.824,0,4.257-1.454,4.257-4.322,0-.419-.029-.806-.087-1.163-.165-1.494-.253-3.12-.253-4.706,0-.926,.032-1.761,.083-2.502,.944-.818,2.703-2.009,5.191-2.307,2.212-.265,4.226,.34,5.261,.742,.008,.312,.013,.643,.013,.994,0,.81-.024,1.78-.064,2.722-.435-.101-.923-.151-1.462-.151-2.824,0-4.257,1.455-4.257,4.323,0,2.909,1.393,4.322,4.258,4.322,2.824,0,4.257-1.454,4.257-4.322,0-.247-.024-.751-.022-.772Z" />
    </svg>
  );
}
